import React from 'react';
import { Grid2, TextField } from '@mui/material';

function PinterestForm({ values, setFieldValue }) {
    return (
        <>
            <Grid2 size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    label="Pinterest Tag ID"
                    value={values.settings?.trackingId || ''}
                    onChange={(ev) =>
                        setFieldValue('settings', {
                            ...values.settings,
                            trackingId: ev.target.value,
                        })
                    }
                    placeholder="2612345678901"
                    helperText="Enter your Pinterest Tag ID"
                />
            </Grid2>
        </>
    );
}

export default PinterestForm;
